import color from 'color';
import normalizeColors from '../libs/normalizeColors';
import { fromJS } from 'immutable';
export var mobileFirstMobileBreakpoint = '@media screen and (min-width: 0px)';
export var mobileFirstRestrictedMobileBreakpoint = '@media screen and (min-width: 0px) and (max-width: 767px)';
export var mobileFirstTabletBreakpoint = '@media screen and (min-width: 768px)';
export var mobileFirstRestrictedTabletBreakpoint = '@media screen and (min-width: 768px) and (max-width: 990px)';
export var mobileFirstLaptopBreakpoint = '@media screen and (min-width: 991px)';
export var mobileFirstRestrictedLaptopBreakpoint = '@media screen and (min-width: 991px) and (max-width: 1199px)';
export var mobileFirstDesktopBreakpoint = '@media screen and (min-width: 1200px)';
export var mobileFirstRestrictedDesktopBreakpoint = '@media screen and (min-width: 1200px) and (max-width: 1599px)';
export var mobileFirstDesktopLargeBreakpoint = '@media screen and (min-width: 1600px)';
export var mobileFirstRestrictedDesktopLargeBreakpoint = '@media all and (min-width: 1600px)';
export default fromJS({
  colors: normalizeColors({
    primary: '#00b2d5',
    primaryLight: color('#00b2d5').lighten(0.6),
    secondary: 'hsl(50, 100%, 50%)',
    primaryDarker: color('#00b2d5').darken(0.2).hex(),
    secondaryDarker: color('hsl(50, 100%, 50%)').darken(0.2).hex(),
    info: '#a5cd38',
    warning: '#ed983b',
    error: 'hsl(351, 100%, 42%)',
    neutral: '#d5dbe4',
    success: 'hsl(120, 100%, 42%)',
    black: '#333333',
    grayDarker: 'hsl(0, 0%, 20%)',
    grayDark: 'hsl(0, 0%, 30%)',
    gray: 'hsl(0, 0%, 50%)',
    grayLight: 'hsl(0, 0%, 70%)',
    grayLighter: 'hsl(0, 0%, 85%)',
    grayLightest: 'hsl(0, 0%, 90%)',
    monotone1: '#f2f2f2',
    monotone2: '#d5d5d5',
    monotone3: '#959595',
    monotone4: '#555555',
    monotone5: '#363636',
    white: 'hsl(0, 0%, 100%)',
    border: 'hsl(0, 0%, 60%)',
    yellowDark: '#877103',
    yellowLight: '#FFD900',
    textPrimary: 'hsl(0, 0%, 25%)',
    textSecondary: 'hsl(0, 0%, 50%)',
    background: '#fff',
    backgroundDarker: '#E4E6EA',
    backgroundFooter: '#303A3D',
    link: '#00b2d5'
  }),
  mediaQueries: {
    breakpointLarge: '@media screen and (min-width: 769px)',
    breakpointLaptop: '@media screen and (max-width: 1200px)',
    breakpointLaptopSmall: '@media screen and (max-width: 991px)',
    breakpointTablet: '@media screen and (max-width: 768px)',
    breakpointSmall: '@media screen and (max-width: 480px)',
    retina: '@media (-webkit-min-device-pixel-ratio: 2)',
    smallScreen: '@media (max-width: 480px), (max-height: 414px)',
    laptop: '@media (min-width: 992px) and (max-width: 1200px)',
    laptopSmall: '@media (min-width: 769px) and (max-width: 991px)',
    tablet: '@media (min-width: 481px) and (max-width: 768px)',
    wideDesktop: '@media (min-width: 1600px)'
  },
  mobileFirstMediaQueries: {
    mobile: mobileFirstMobileBreakpoint,
    tablet: mobileFirstTabletBreakpoint,
    laptop: mobileFirstLaptopBreakpoint,
    desktop: mobileFirstDesktopBreakpoint,
    desktopLarge: mobileFirstDesktopLargeBreakpoint
  },
  sizes: {
    inputHeight: '48px',
    container: '1170px',
    infoContainer: '620px',
    gutterWidth: 15,
    columns: 12
  },
  borders: {
    calculator: 0
  },
  breakpoints: [{
    name: 'MOBILE',
    query: mobileFirstMobileBreakpoint
  }, {
    name: 'TABLET',
    query: mobileFirstTabletBreakpoint
  }, {
    name: 'LAPTOP',
    query: mobileFirstLaptopBreakpoint
  }, {
    name: 'DESKTOP',
    query: mobileFirstDesktopBreakpoint
  }, {
    name: 'DESKTOP_LARGE',
    query: mobileFirstDesktopLargeBreakpoint
  }],
  restrictedBreakpoints: [{
    name: 'MOBILE',
    query: mobileFirstRestrictedMobileBreakpoint
  }, {
    name: 'TABLET',
    query: mobileFirstRestrictedTabletBreakpoint
  }, {
    name: 'LAPTOP',
    query: mobileFirstRestrictedLaptopBreakpoint
  }, {
    name: 'DESKTOP',
    query: mobileFirstRestrictedDesktopBreakpoint
  }, {
    name: 'DESKTOP_LARGE',
    query: mobileFirstRestrictedDesktopLargeBreakpoint
  }],
  containers: {
    tablet: 750,
    laptop: 970,
    desktop: 1170
  }
});